/**
 * Downloads a file with the given name. Cross-origin files are fetched as a blob so the
 * browser saves them instead of navigating; if the host blocks that (CORS), the file
 * opens in a new tab where it can be saved.
 */
export async function downloadFile(url: string, fileName: string) {
  try {
    const response = await fetch(url, { mode: 'cors' })
    if (!response.ok) throw new Error(`Download failed (${response.status})`)
    const blob = await response.blob()
    const objectUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = objectUrl
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000)
  } catch {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
}
